/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
import * as Types from "../../../../__graphql__/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type DeleteImageInput = {
  publicId: string;
};

export type GenerateSignatureInput = {
  folder: string;
  publicId?: string | null | undefined;
};

export type GenerateCloudinarySignatureMutationVariables = Exact<{
  input: Types.GenerateSignatureInput;
}>;

export type GenerateCloudinarySignatureMutation = {
  generateCloudinarySignature: {
    apiKey: string;
    cloudName: string;
    signature: string;
    timestamp: number;
  };
};

export type DeleteCloudinaryImageMutationVariables = Exact<{
  input: Types.DeleteImageInput;
}>;

export type DeleteCloudinaryImageMutation = { deleteCloudinaryImage: { success: boolean } };

export const GenerateCloudinarySignatureDocument = gql`
  mutation GenerateCloudinarySignature($input: GenerateSignatureInput!) {
    generateCloudinarySignature(input: $input) {
      apiKey
      cloudName
      signature
      timestamp
    }
  }
`;
export type GenerateCloudinarySignatureMutationFn = Apollo.MutationFunction<
  GenerateCloudinarySignatureMutation,
  GenerateCloudinarySignatureMutationVariables
>;

/**
 * __useGenerateCloudinarySignatureMutation__
 *
 * To run a mutation, you first call `useGenerateCloudinarySignatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateCloudinarySignatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateCloudinarySignatureMutation, { data, loading, error }] = useGenerateCloudinarySignatureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateCloudinarySignatureMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateCloudinarySignatureMutation,
    GenerateCloudinarySignatureMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GenerateCloudinarySignatureMutation,
    GenerateCloudinarySignatureMutationVariables
  >(GenerateCloudinarySignatureDocument, options);
}
export type GenerateCloudinarySignatureMutationHookResult = ReturnType<
  typeof useGenerateCloudinarySignatureMutation
>;
export type GenerateCloudinarySignatureMutationResult =
  Apollo.MutationResult<GenerateCloudinarySignatureMutation>;
export type GenerateCloudinarySignatureMutationOptions = Apollo.BaseMutationOptions<
  GenerateCloudinarySignatureMutation,
  GenerateCloudinarySignatureMutationVariables
>;
export const DeleteCloudinaryImageDocument = gql`
  mutation DeleteCloudinaryImage($input: DeleteImageInput!) {
    deleteCloudinaryImage(input: $input) {
      success
    }
  }
`;
export type DeleteCloudinaryImageMutationFn = Apollo.MutationFunction<
  DeleteCloudinaryImageMutation,
  DeleteCloudinaryImageMutationVariables
>;

/**
 * __useDeleteCloudinaryImageMutation__
 *
 * To run a mutation, you first call `useDeleteCloudinaryImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCloudinaryImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCloudinaryImageMutation, { data, loading, error }] = useDeleteCloudinaryImageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCloudinaryImageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCloudinaryImageMutation,
    DeleteCloudinaryImageMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteCloudinaryImageMutation, DeleteCloudinaryImageMutationVariables>(
    DeleteCloudinaryImageDocument,
    options,
  );
}
export type DeleteCloudinaryImageMutationHookResult = ReturnType<
  typeof useDeleteCloudinaryImageMutation
>;
export type DeleteCloudinaryImageMutationResult =
  Apollo.MutationResult<DeleteCloudinaryImageMutation>;
export type DeleteCloudinaryImageMutationOptions = Apollo.BaseMutationOptions<
  DeleteCloudinaryImageMutation,
  DeleteCloudinaryImageMutationVariables
>;
